module.exports = __webpack_public_path__ + "d71ec35c28c136e38f6b9af60567ec62.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-3.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-5/reviews-section-5/review-3.jpg
// module chunks = 40